import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/user.css';
import '../styles/buttons.css';


function Landing() {
  return (
    <div className="App">
      <div className="landing-container">
        <h2>FriendsFitness</h2>
        <p>Track your workouts, monitor your progress, and achieve your goals.</p>
        <Link to="/login">
          <button className="btn-primary">Login</button>
        </Link>
      </div>
    </div>
  );
}

export default Landing;